import { Link } from "react-router-dom";
import { HexBg } from "./Decor";

export function PageHero({ eyebrow, title, accent, sub, crumb, image }) {
  return (
    <section className="page-hero">
      {image && (
        <div className="page-hero-bg" style={{ backgroundImage: `url(${image})` }} aria-hidden="true"></div>
      )}
      <HexBg />
      <div className="page-hero-inner">
        {crumb && (
          <div className="breadcrumb fade-up">
            <Link to="/">Home</Link>
            <span>/</span>
            <span style={{ color: "rgba(255,255,255,0.6)" }}>{crumb}</span>
          </div>
        )}
        <div className="fade-up d1">
          {eyebrow && <span className="s-eye on-dark">{eyebrow}</span>}
        </div>
        <h1 className="fade-up d1">
          {title} {accent && <span className="accent grad-text">{accent}</span>}
        </h1>
        {sub && <p className="hero-sub fade-up d2">{sub}</p>}
      </div>
    </section>
  );
}

export function CtaSection({
  eyebrow = "Let's Talk",
  title = "Enterprise expertise.",
  accent = "Accessible costs.",
  lead = "Whether you need a one-time WMS health check or an ongoing fractional analyst — start with a free 60-minute discovery call. No sales pitch, just a practical conversation about your operation.",
}) {
  return (
    <section id="cta">
      <div className="s-inner">
        <div className="fade-up">
          <span className="s-eye on-dark">{eyebrow}</span>
          <h2>{title} <span className="accent grad-text">{accent}</span></h2>
          <p className="s-lead">{lead}</p>
          <div className="cta-btns">
            <Link to="/contact" className="btn-lg primary" data-testid="cta-schedule-btn">Schedule a Discovery Call ↗</Link>
            <Link to="/services" className="btn-lg ghost" data-testid="cta-services-btn">View All Services</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export function PlatformsBand() {
  const items = [
    "Manhattan Associates", "Blue Yonder", "Körber", "SAP EWM", "Oracle WMS",
    "Infor WMS", "NetSuite WMS", "Manhattan SCALE", "Softeon", "Deposco",
  ];
  return (
    <section className="platforms-band">
      <div className="s-inner">
        <p className="platforms-label fade-up">Platforms &amp; systems we work across</p>
        <div className="marquee" aria-hidden="false">
          <div className="marquee-track">
            {[...items, ...items].map((p, i) => (
              <span className="platform-chip" key={i}>{p}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function ImageBand({ image, eyebrow, title, text, points = [] }) {
  return (
    <section className="img-band">
      <div className="s-inner img-band-inner">
        <div className="img-band-media fade-left">
          <div className="img-band-frame">
            <img src={image} alt={title} loading="lazy" />
          </div>
        </div>
        <div className="img-band-copy fade-right">
          {eyebrow && <span className="s-eye">{eyebrow}</span>}
          <h2>{title}</h2>
          {text && <p className="s-lead" style={{ marginBottom: points.length ? 22 : 0 }}>{text}</p>}
          {points.length > 0 && (
            <ul className="svc-list">
              {points.map((p) => <li key={p}>{p}</li>)}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
}
